import { render } from "./blog-content-create-import.vue?vue&type=template&id=b347832a"
import script from "./blog-content-create-import.vue?vue&type=script&lang=js"
export * from "./blog-content-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__